import React from 'react';
import { RotateCw } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from '@/components/ui/alert-dialog';

const n = (k, one, many) => `${k} ${k === 1 ? one : many}`;

export function FollowupResendButton({ ids, onDone }) {
  const send = async () => {
    try {
      const { data } = await api.post('/wa-followup/resend', { contact_ids: ids });
      toast.success(`Reenviando la bienvenida a ${n(data.queued, 'congregación', 'congregaciones')}${data.skipped ? ` (${n(data.skipped, 'omitida', 'omitidas')})` : ''}`);
      onDone();
    } catch (e) {
      toast.error(errText(e, 'No se pudo reenviar'));
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button disabled={!ids.length} data-testid="followup-resend-button">
          <RotateCw className="h-4 w-4 mr-1" />Volver a enviar ({ids.length})
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="followup-resend-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>¿Volver a enviar la bienvenida por WhatsApp?</AlertDialogTitle>
          <AlertDialogDescription>
            Se enviará otra vez la plantilla de bienvenida aprobada a {n(ids.length, 'congregación', 'congregaciones')}. Cada envío cuenta para el límite diario de WhatsApp y Meta puede limitar tu número si muchos lo bloquean, así que no lo reenvíes muy seguido.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="followup-resend-cancel">Cancelar</AlertDialogCancel>
          <AlertDialogAction onClick={send} data-testid="followup-resend-confirm">Enviar</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
